import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'page-not-found',
  templateUrl: './404.component.html',
})
export class PageNotFoundComponent {

	constructor(private sanitizer: DomSanitizer) { }

	title: any;
	subtitle: any;
	header: any;
	headerHeight: any;
	headerAlign: any;

	/* On with the show */
	ngOnInit() {
		this.headerHeight = '470px';
		this.title = 'Identity RPG';
		this.subtitle = 'CHANGING WHAT IT MEANS TO BE AN MMORPG';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("/assets/img/header-square.jpg")' );
	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/404.component.ts